export const currencyData = {
  AED: {
    symbol: "د.إ",
    name: "UAE Dirham",
    symbol_native: "د.إ",
    decimal_digits: 2,
    rounding: 0,
    code: "AED",
    name_plural: "UAE dirhams",
    countryCode: "AE",
    defaultLanguage: "ar",
  },
  AFN: {
    symbol: "؋",
    name: "Afghan Afghani",
    symbol_native: "؋",
    decimal_digits: 2,
    rounding: 0,
    code: "AFN",
    name_plural: "Afghan afghanis",
    countryCode: "AF",
    defaultLanguage: "ps",
  },
  ALL: {
    symbol: "Lek",
    name: "Albanian lek",
    symbol_native: "Lek",
    decimal_digits: 2,
    rounding: 0,
    code: "ALL",
    name_plural: "Albanian leks",
    countryCode: "AL",
    defaultLanguage: "sq",
  },
  AMD: {
    symbol: "֏",
    name: "Armenian Dram",
    symbol_native: "֏",
    decimal_digits: 2,
    rounding: 0,
    code: "AMD",
    name_plural: "Armenian drams",
    countryCode: "AM",
    defaultLanguage: "hy",
  },
  ANG: {
    symbol: "ƒ",
    name: "Netherlands Antillean Guilder",
    symbol_native: "ƒ",
    decimal_digits: 2,
    rounding: 0,
    code: "ANG",
    name_plural: "Netherlands Antillean guilders",
    countryCode: "AN",
    defaultLanguage: "nl",
  },
  ARS: {
    symbol: "$",
    name: "Argentine Peso",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "ARS",
    name_plural: "Argentine pesos",
    countryCode: "AR",
    defaultLanguage: "es",
  },
  ATF: {
    symbol: "€",
    name: "Euro",
    symbol_native: "€",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros",
    countryCode: "ATF",
    defaultLanguage: "fr",
  },
  AU: {
    symbol: "$",
    name: "Australian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "AUD",
    name_plural: "Australian dollars",
    countryCode: "AU",
    defaultLanguage: "en",
  },
  AUD: {
    symbol: "$",
    name: "Australian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "AUD",
    name_plural: "Australian dollars",
    countryCode: "AU",
    defaultLanguage: "en",
  },
  AWG: {
    symbol: "ƒ",
    name: "Aruban Guilder",
    symbol_native: "ƒ",
    decimal_digits: 2,
    rounding: 0,
    code: "AWG",
    name_plural: "Aruban guilders",
    countryCode: "AW",
    defaultLanguage: "nl",
  },
  AZN: {
    symbol: "₼",
    name: "Azerbaijani Manat",
    symbol_native: "₼",
    decimal_digits: 2,
    rounding: 0,
    code: "AZN",
    name_plural: "Azerbaijani manats",
    countryCode: "AZ",
    defaultLanguage: "az",
  },
  BAM: {
    symbol: "KM",
    name: "Convertible Mark",
    symbol_native: "KM",
    decimal_digits: 2,
    rounding: 0,
    code: "BAM",
    name_plural: "Convertible marks",
    countryCode: "BA",
    defaultLanguage: "bs",
  },
  BBD: {
    symbol: "$",
    name: "Barbadian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "BBD",
    name_plural: "Barbadian dollars",
    countryCode: "BB",
    defaultLanguage: "en",
  },
  BDT: {
    symbol: "৳",
    name: "Bangladeshi Taka",
    symbol_native: "৳",
    decimal_digits: 2,
    rounding: 0,
    code: "BDT",
    name_plural: "Bangladeshi takas",
    countryCode: "BD",
    defaultLanguage: "bn",
  },
  BF: {
    symbol: "Fr",
    name: "CFA Franc BCEAO",
    symbol_native: "Fr",
    decimal_digits: 0,
    rounding: 0,
    code: "XOF",
    name_plural: "CFA francs BCEAO",
    countryCode: "BF",
    defaultLanguage: "fr",
  },
  BGN: {
    symbol: "лв",
    name: "Bulgarian Lev",
    symbol_native: "лв",
    decimal_digits: 2,
    rounding: 0,
    code: "BGN",
    name_plural: "Bulgarian leva",
    countryCode: "BG",
    defaultLanguage: "bg",
  },
  BHD: {
    symbol: ".د.ب",
    name: "Bahraini Dinar",
    symbol_native: ".د.ب",
    decimal_digits: 3,
    rounding: 0,
    code: "BHD",
    name_plural: "Bahraini dinars",
    countryCode: "BH",
    defaultLanguage: "ar",
  },
  BIF: {
    symbol: "Fr",
    name: "Burundian Franc",
    symbol_native: "Fr",
    decimal_digits: 0,
    rounding: 0,
    code: "BIF",
    name_plural: "Burundian francs",
    countryCode: "BI",
    defaultLanguage: "fr",
  },
  BMD: {
    symbol: "$",
    name: "Bermudian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "BMD",
    name_plural: "Bermudian dollars",
    countryCode: "BM",
    defaultLanguage: "en",
  },
  BND: {
    symbol: "$",
    name: "Brunei Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "BND",
    name_plural: "Brunei dollars",
    countryCode: "BN",
    defaultLanguage: "ms",
  },
  BOB: {
    symbol: "Bs",
    name: "Boliviano",
    symbol_native: "Bs",
    decimal_digits: 2,
    rounding: 0,
    code: "BOB",
    name_plural: "Bolivianos",
    countryCode: "BO",
    defaultLanguage: "es",
  },
  BRL: {
    symbol: "R$",
    name: "Brazilian Real",
    symbol_native: "R$",
    decimal_digits: 2,
    rounding: 0,
    code: "BRL",
    name_plural: "Brazilian reals",
    countryCode: "BR",
    defaultLanguage: "pt",
  },
  BSD: {
    symbol: "$",
    name: "Bahamian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "BSD",
    name_plural: "Bahamian dollars",
    countryCode: "BS",
    defaultLanguage: "en",
  },
  BTN: {
    symbol: "Nu.",
    name: "Bhutanese Ngultrum",
    symbol_native: "Nu.",
    decimal_digits: 2,
    rounding: 0,
    code: "BTN",
    name_plural: "Bhutanese ngultrums",
    countryCode: "BT",
    defaultLanguage: "dz",
  },
  BWP: {
    symbol: "P",
    name: "Botswana Pula",
    symbol_native: "P",
    decimal_digits: 2,
    rounding: 0,
    code: "BWP",
    name_plural: "Botswana pulas",
    countryCode: "BW",
    defaultLanguage: "en",
  },
  BYN: {
    symbol: "Br",
    name: "Belarusian Ruble",
    symbol_native: "Br",
    decimal_digits: 2,
    rounding: 0,
    code: "BYN",
    name_plural: "Belarusian rubles",
    countryCode: "BY",
    defaultLanguage: "be",
  },
  BZD: {
    symbol: "$",
    name: "Belize Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "BZD",
    name_plural: "Belize dollars",
    countryCode: "BZ",
    defaultLanguage: "en",
  },
  CAD: {
    symbol: "$",
    name: "Canadian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "CAD",
    name_plural: "Canadian dollars",
    countryCode: "CA",
    defaultLanguage: "en",
  },
  CDF: {
    symbol: "Fr",
    name: "Congolese Franc",
    symbol_native: "Fr",
    decimal_digits: 2,
    rounding: 0,
    code: "CDF",
    name_plural: "Congolese francs",
    countryCode: "CD",
    defaultLanguage: "fr",
  },
  CH: {
    symbol: "Fr",
    name: "Swiss Franc",
    symbol_native: "Fr",
    decimal_digits: 2,
    rounding: 0,
    code: "CHF",
    name_plural: "Swiss francs",
    countryCode: "CH",
    defaultLanguage: "de",
  },
  CHF: {
    symbol: "CHF",
    name: "Swiss Franc",
    symbol_native: "CHF",
    decimal_digits: 2,
    rounding: 0,
    code: "CHF",
    name_plural: "Swiss francs",
    countryCode: "LI",
    defaultLanguage: "de",
  },
  CI: {
    symbol: "Fr",
    name: "CFA Franc BCEAO",
    symbol_native: "Fr",
    decimal_digits: 2,
    rounding: 0,
    code: "XOF",
    name_plural: "CFA francs BCEAO",
    countryCode: "CI",
    defaultLanguage: "fr",
  },
  CLP: {
    symbol: "$",
    name: "Chilean Peso",
    symbol_native: "$",
    decimal_digits: 0,
    rounding: 0,
    code: "CLP",
    name_plural: "Chilean pesos",
    countryCode: "CL",
    defaultLanguage: "es",
  },
  CM: {
    symbol: "Fr",
    name: "CFA Franc BEAC",
    symbol_native: "Fr",
    decimal_digits: 0,
    rounding: 0,
    code: "XAF",
    name_plural: "CFA francs BEAC",
    countryCode: "CM",
    defaultLanguage: "fr",
  },
  CNY: {
    symbol: "¥",
    name: "Chinese Yuan Renminbi (RMB)",
    symbol_native: "¥",
    decimal_digits: 2,
    rounding: 0,
    code: "CNY",
    name_plural: "Chinese yuan",
    countryCode: "CN",
    defaultLanguage: "zh",
  },
  COP: {
    symbol: "$",
    name: "Colombian Peso",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "COP",
    name_plural: "Colombian pesos",
    countryCode: "CO",
    defaultLanguage: "es",
  },
  CRC: {
    symbol: "₡",
    name: "Costa Rican Colon",
    symbol_native: "₡",
    decimal_digits: 2,
    rounding: 0,
    code: "CRC",
    name_plural: "Costa Rican colons",
    countryCode: "CR",
    defaultLanguage: "es",
  },
  CUC: {
    symbol: "$",
    name: "Cuban Convertible Peso (->CUP)",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "CUC",
    name_plural: "Cuban convertible pesos",
    countryCode: "CU",
    defaultLanguage: "es",
  },
  CVE: {
    symbol: "$",
    name: "Cape Verde Escudo",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "CVE",
    name_plural: "Cape Verde escudos",
    countryCode: "CV",
    defaultLanguage: "pt",
  },
  CX: {
    symbol: "$",
    name: "Australian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "AUD",
    name_plural: "Australian dollars",
    countryCode: "CX",
    defaultLanguage: "en",
  },
  CY: {
    symbol: "€",
    name: "Euro",
    symbol_native: "€",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros",
    countryCode: "CY",
    defaultLanguage: "el",
  },
  CZK: {
    symbol: "Kč",
    name: "Czech Koruna",
    symbol_native: "Kč",
    decimal_digits: 2,
    rounding: 0,
    code: "CZK",
    name_plural: "Czech koruny",
    countryCode: "CS",
    defaultLanguage: "cs",
  },
  DE: {
    symbol: "€",
    name: "Euro",
    symbol_native: "€",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros",
    countryCode: "DE",
    defaultLanguage: "de",
  },
  DJF: {
    symbol: "Fdj",
    name: "Djiboutian Franc",
    symbol_native: "Fdj",
    decimal_digits: 0,
    rounding: 0,
    code: "DJF",
    name_plural: "Djiboutian francs",
    countryCode: "DJ",
    defaultLanguage: "fr",
  },
  DKK: {
    symbol: "kr",
    name: "Danish Krone",
    symbol_native: "kr",
    decimal_digits: 2,
    rounding: 0,
    code: "DKK",
    name_plural: "Danish kroner",
    countryCode: "DK",
    defaultLanguage: "da",
  },
  DM: {
    symbol: "$",
    name: "East Caribbean Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "XCD",
    name_plural: "East Caribbean dollars",
    countryCode: "DM",
    defaultLanguage: "en",
  },
  DOP: {
    symbol: "RD$",
    name: "Dominican Peso",
    symbol_native: "RD$",
    decimal_digits: 2,
    rounding: 0,
    code: "DOP",
    name_plural: "Dominican pesos",
    countryCode: "DO",
    defaultLanguage: "es",
  },
  DZD: {
    symbol: "دج",
    name: "Algerian dinar",
    symbol_native: "دج",
    decimal_digits: 2,
    rounding: 0,
    code: "DZD",
    name_plural: "Algerian dinars",
    countryCode: "DZ",
    defaultLanguage: "ar",
  },
  EC: {
    symbol: "$",
    name: "US Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "USD",
    name_plural: "US dollars",
    countryCode: "EC",
    defaultLanguage: "en",
  },
  EGP: {
    symbol: "ج.م",
    name: "Egyptian Pound",
    symbol_native: "ج.م",
    decimal_digits: 2,
    rounding: 0,
    code: "EGP",
    name_plural: "Egyptian pounds",
    countryCode: "EG",
    defaultLanguage: "ar",
  },
  ERN: {
    symbol: "Nfa",
    name: "Eritrean Nakfa",
    symbol_native: "Nfa",
    decimal_digits: 2,
    rounding: 0,
    code: "ERN",
    name_plural: "Eritrean nakfas",
    countryCode: "ER",
    defaultLanguage: "ti",
  },
  ES: {
    symbol: "€",
    name: "Euro",
    symbol_native: "€",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros",
    countryCode: "ES",
    defaultLanguage: "es",
  },
  ETB: {
    symbol: "Br",
    name: "Ethiopian Birr",
    symbol_native: "Br",
    decimal_digits: 2,
    rounding: 0,
    code: "ETB",
    name_plural: "Ethiopian birrs",
    countryCode: "ET",
    defaultLanguage: "am",
  },
  EUR: {
    symbol: "€",
    name: "Euro",
    symbol_native: "€",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros",
    countryCode: "HR",
    defaultLanguage: "hr",
  },
  FI: {
    symbol: "€",
    name: "Euro",
    symbol_native: "€",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros",
    countryCode: "FI",
    defaultLanguage: "fi",
  },
  FJD: {
    symbol: "$",
    name: "Fijian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "FJD",
    name_plural: "Fijian dollars",
    countryCode: "FJ",
    defaultLanguage: "en",
  },
  FKP: {
    symbol: "£",
    name: "Falkland Islands Pound",
    symbol_native: "£",
    decimal_digits: 2,
    rounding: 0,
    code: "FKP",
    name_plural: "Falkland Islands pounds",
    countryCode: "FK",
    defaultLanguage: "en",
  },
  FM: {
    symbol: "$",
    name: "US Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "USD",
    name_plural: "US dollars",
    countryCode: "FM",
    defaultLanguage: "en",
  },
  FO: {
    symbol: "kr",
    name: "Danish Krone",
    symbol_native: "kr",
    decimal_digits: 2,
    rounding: 0,
    code: "DKK",
    name_plural: "Danish kroner",
    countryCode: "FO",
    defaultLanguage: "da",
  },
  FR: {
    symbol: "€",
    name: "Euro",
    symbol_native: "€",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros",
    countryCode: "FR",
    defaultLanguage: "fr",
  },
  FXX: {
    symbol: "€",
    name: "Euro",
    symbol_native: "€",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros",
    countryCode: "FXX",
    defaultLanguage: "fr",
  },
  GA: {
    symbol: "Fr",
    name: "CFA Franc BEAC",
    symbol_native: "Fr",
    decimal_digits: 2,
    rounding: 0,
    code: "XAF",
    name_plural: "CFA francs BEAC",
    countryCode: "GA",
    defaultLanguage: "fr",
  },
  GB: {
    symbol: "£",
    name: "Pound Sterling",
    symbol_native: "£",
    decimal_digits: 2,
    rounding: 0,
    code: "GBP",
    name_plural: "pounds sterling",
    countryCode: "GB",
    defaultLanguage: "en",
  },
  GBP: {
    symbol: "£",
    name: "Pound Sterling",
    symbol_native: "£",
    decimal_digits: 2,
    rounding: 0,
    code: "GBP",
    name_plural: "Pounds sterling",
    countryCode: "IO",
    defaultLanguage: "en",
  },
  GD: {
    symbol: "$",
    name: "East Caribbean Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "XCD",
    name_plural: "East Caribbean dollars",
    countryCode: "GD",
    defaultLanguage: "en",
  },
  GEL: {
    symbol: "₾",
    name: "Georgian Lari",
    symbol_native: "₾",
    decimal_digits: 2,
    rounding: 0,
    code: "GEL",
    name_plural: "Georgian lari",
    countryCode: "GE",
    defaultLanguage: "ka",
  },
  GGP: {
    symbol: "£",
    name: "Guernsey Pound",
    symbol_native: "£",
    decimal_digits: 2,
    rounding: 0,
    code: "GGP",
    name_plural: "Guernsey pounds",
    countryCode: "GG",
    defaultLanguage: "en",
  },
  GHS: {
    symbol: "₵",
    name: "Ghanaian Cedi",
    symbol_native: "₵",
    decimal_digits: 2,
    rounding: 0,
    code: "GHS",
    name_plural: "Ghanaian cedis",
    countryCode: "GH",
    defaultLanguage: "en",
  },
  GIP: {
    symbol: "£",
    name: "Gibraltar Pound",
    symbol_native: "£",
    decimal_digits: 2,
    rounding: 0,
    code: "GIP",
    name_plural: "Gibraltar pounds",
    countryCode: "GI",
    defaultLanguage: "en",
  },
  GL: {
    symbol: "kr",
    name: "Danish Krone",
    symbol_native: "kr",
    decimal_digits: 2,
    rounding: 0,
    code: "DKK",
    name_plural: "Danish kroner",
    countryCode: "GL",
    defaultLanguage: "da",
  },
  GMD: {
    symbol: "D",
    name: "Gambian Dalasi",
    symbol_native: "D",
    decimal_digits: 2,
    rounding: 0,
    code: "GMD",
    name_plural: "Gambian dalasi",
    countryCode: "GM",
    defaultLanguage: "en",
  },
  GNF: {
    symbol: "Fr",
    name: "Guinean Franc",
    symbol_native: "Fr",
    decimal_digits: 0,
    rounding: 0,
    code: "GNF",
    name_plural: "Guinean francs",
    countryCode: "GN",
    defaultLanguage: "fr",
  },
  GP: {
    symbol: "€",
    name: "Euro",
    symbol_native: "€",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros",
    countryCode: "GP",
    defaultLanguage: "fr",
  },
  GR: {
    symbol: "€",
    name: "Euro",
    symbol_native: "€",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros",
    countryCode: "GR",
    defaultLanguage: "el",
  },
  GS: {
    symbol: "£",
    name: "Pound Sterling",
    symbol_native: "£",
    decimal_digits: 2,
    rounding: 0,
    code: "GBP",
    name_plural: "Pounds sterling",
    countryCode: "GS",
    defaultLanguage: "en",
  },
  GTQ: {
    symbol: "Q",
    name: "Guatemalan Quetzal",
    symbol_native: "Q",
    decimal_digits: 2,
    rounding: 0,
    code: "GTQ",
    name_plural: "Guatemalan quetzals",
    countryCode: "GT",
    defaultLanguage: "es",
  },
  GU: {
    symbol: "$",
    name: "US Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "USD",
    name_plural: "US dollars",
    countryCode: "GU",
    defaultLanguage: "en",
  },
  GUF: {
    symbol: "€",
    name: "Euro",
    symbol_native: "€",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros",
    countryCode: "GUF",
    defaultLanguage: "fr",
  },
  GW: {
    symbol: "Fr",
    name: "CFA Franc BCEAO",
    symbol_native: "Fr",
    decimal_digits: 2,
    rounding: 0,
    code: "XOF",
    name_plural: "CFA francs BCEAO",
    countryCode: "GW",
    defaultLanguage: "fr",
  },
  GYD: {
    symbol: "$",
    name: "Guyanese Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "GYD",
    name_plural: "Guyanese dollars",
    countryCode: "GY",
    defaultLanguage: "en",
  },
  HKD: {
    symbol: "$",
    name: "Hong Kong Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "HKD",
    name_plural: "Hong Kong dollars",
    countryCode: "HK",
    defaultLanguage: "zh",
  },
  HM: {
    symbol: "$",
    name: "Australian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "AUD",
    name_plural: "Australian dollars",
    countryCode: "HM",
    defaultLanguage: "en",
  },
  HNL: {
    symbol: "L",
    name: "Honduran Lempira",
    symbol_native: "L",
    decimal_digits: 2,
    rounding: 0,
    code: "HNL",
    name_plural: "Honduran lempiras",
    countryCode: "HN",
    defaultLanguage: "es",
  },
  HTG: {
    symbol: "G",
    name: "Haitian Gourde",
    symbol_native: "G",
    decimal_digits: 2,
    rounding: 0,
    code: "HTG",
    name_plural: "Haitian gourdes",
    countryCode: "HT",
    defaultLanguage: "ht",
  },
  HUF: {
    symbol: "Ft",
    name: "Hungarian Forint",
    symbol_native: "Ft",
    decimal_digits: 2,
    rounding: 0,
    code: "HUF",
    name_plural: "Hungarian forints",
    countryCode: "HU",
    defaultLanguage: "hu",
  },
  IDR: {
    symbol: "Rp",
    name: "Indonesian Rupiah",
    symbol_native: "Rp",
    decimal_digits: 2,
    rounding: 0,
    code: "IDR",
    name_plural: "Indonesian rupiahs",
    countryCode: "ID",
    defaultLanguage: "id",
  },
  IE: {
    symbol: "€",
    name: "Euro",
    symbol_native: "€",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros",
    countryCode: "IE",
    defaultLanguage: "en",
  },
  ILS: {
    symbol: "₪",
    name: "Israeli New Shekel",
    symbol_native: "₪",
    decimal_digits: 2,
    rounding: 0,
    code: "ILS",
    name_plural: "Israeli new shekels",
    countryCode: "IL",
    defaultLanguage: "he",
  },
  IMP: {
    symbol: "£",
    name: "Manx Pound",
    symbol_native: "£",
    decimal_digits: 2,
    rounding: 0,
    code: "IMP",
    name_plural: "Manx pounds",
    countryCode: "IM",
    defaultLanguage: "en",
  },
  INR: {
    symbol: "₹",
    name: "Indian Rupee",
    symbol_native: "₹",
    decimal_digits: 2,
    rounding: 0,
    code: "INR",
    name_plural: "Indian rupees",
    countryCode: "IN",
    defaultLanguage: "hi",
  },
  IQD: {
    symbol: "ع.د",
    name: "Iraqi Dinar",
    symbol_native: "ع.د",
    decimal_digits: 3,
    rounding: 0,
    code: "IQD",
    name_plural: "Iraqi dinars",
    countryCode: "IQ",
    defaultLanguage: "ar",
  },
  IRR: {
    symbol: "﷼",
    name: "Iranian Rial",
    symbol_native: "﷼",
    decimal_digits: 2,
    rounding: 0,
    code: "IRR",
    name_plural: "Iranian rials",
    countryCode: "IR",
    defaultLanguage: "fa",
  },
  ISK: {
    symbol: "kr",
    name: "Icelandic Króna",
    symbol_native: "kr",
    decimal_digits: 0,
    rounding: 0,
    code: "ISK",
    name_plural: "Icelandic krónur",
    countryCode: "IS",
    defaultLanguage: "is",
  },
  IT: {
    symbol: "€",
    name: "Euro",
    symbol_native: "€",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros",
    countryCode: "IT",
    defaultLanguage: "it",
  },
  JEP: {
    symbol: "£",
    name: "Jersey Pound",
    symbol_native: "£",
    decimal_digits: 2,
    rounding: 0,
    code: "JEP",
    name_plural: "Jersey pounds",
    countryCode: "JE",
    defaultLanguage: "en",
  },
  JMD: {
    symbol: "$",
    name: "Jamaican Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "JMD",
    name_plural: "Jamaican dollars",
    countryCode: "JM",
    defaultLanguage: "en",
  },
  JOD: {
    symbol: "د.ا",
    name: "Jordanian Dinar",
    symbol_native: "د.ا",
    decimal_digits: 3,
    rounding: 0,
    code: "JOD",
    name_plural: "Jordanian dinars",
    countryCode: "JO",
    defaultLanguage: "ar",
  },
  JPY: {
    symbol: "¥",
    name: "Japanese Yen",
    symbol_native: "¥",
    decimal_digits: 0,
    rounding: 0,
    code: "JPY",
    name_plural: "Japanese yen",
    countryCode: "JP",
    defaultLanguage: "ja",
  },
  KES: {
    symbol: "KSh",
    name: "Kenyan Shilling",
    symbol_native: "KSh",
    decimal_digits: 2,
    rounding: 0,
    code: "KES",
    name_plural: "Kenyan shillings",
    countryCode: "KE",
    defaultLanguage: "en",
  },
  KGS: {
    symbol: "лв",
    name: "Kyrgyzstani Som",
    symbol_native: "лв",
    decimal_digits: 2,
    rounding: 0,
    code: "KGS",
    name_plural: "Kyrgyzstani soms",
    countryCode: "KG",
    defaultLanguage: "ky",
  },
  KHR: {
    symbol: "៛",
    name: "Cambodian Riel",
    symbol_native: "៛",
    decimal_digits: 2,
    rounding: 0,
    code: "KHR",
    name_plural: "Cambodian riels",
    countryCode: "KH",
    defaultLanguage: "km",
  },
  KMF: {
    symbol: "Fr",
    name: "Comoro Franc",
    symbol_native: "Fr",
    decimal_digits: 0,
    rounding: 0,
    code: "KMF",
    name_plural: "Comoro francs",
    countryCode: "KM",
    defaultLanguage: "fr",
  },
  KN: {
    symbol: "$",
    name: "East Caribbean Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "XCD",
    name_plural: "East Caribbean dollars",
    countryCode: "KN",
    defaultLanguage: "en",
  },
  KPW: {
    symbol: "₩",
    name: "North Korean Won",
    symbol_native: "₩",
    decimal_digits: 2,
    rounding: 0,
    code: "KPW",
    name_plural: "North Korean won",
    countryCode: "KP",
    defaultLanguage: "ko",
  },
  KRW: {
    symbol: "₩",
    name: "South Korean Won",
    symbol_native: "₩",
    decimal_digits: 2,
    rounding: 0,
    code: "KRW",
    name_plural: "South Korean won",
    countryCode: "KR",
    defaultLanguage: "ko",
  },
  KWD: {
    symbol: "د.ك",
    name: "Kuwaiti Dinar",
    symbol_native: "د.ك",
    decimal_digits: 3,
    rounding: 0,
    code: "KWD",
    name_plural: "Kuwaiti dinars",
    countryCode: "KW",
    defaultLanguage: "ar",
  },
  KYD: {
    symbol: "$",
    name: "Cayman Islands Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "KYD",
    name_plural: "Cayman Islands dollars",
    countryCode: "KY",
    defaultLanguage: "en",
  },
  KZT: {
    symbol: "₸",
    name: "Kazakhstani Tenge",
    symbol_native: "₸",
    decimal_digits: 2,
    rounding: 0,
    code: "KZT",
    name_plural: "Kazakhstani tenges",
    countryCode: "KZ",
    defaultLanguage: "kk",
  },
  LAK: {
    symbol: "₭",
    name: "Lao Kip",
    symbol_native: "₭",
    decimal_digits: 2,
    rounding: 0,
    code: "LAK",
    name_plural: "Lao kips",
    countryCode: "LA",
    defaultLanguage: "lo",
  },
  LBP: {
    symbol: "ل.ل",
    name: "Lebanese Pound",
    symbol_native: "ل.ل",
    decimal_digits: 2,
    rounding: 0,
    code: "LBP",
    name_plural: "Lebanese pounds",
    countryCode: "LB",
    defaultLanguage: "ar",
  },
  LC: {
    symbol: "$",
    name: "East Caribbean Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "XCD",
    name_plural: "East Caribbean dollars",
    countryCode: "LC",
    defaultLanguage: "en",
  },
  LKR: {
    symbol: "Rs",
    name: "Sri Lankan Rupee",
    symbol_native: "Rs",
    decimal_digits: 2,
    rounding: 0,
    code: "LKR",
    name_plural: "Sri Lankan rupees",
    countryCode: "LK",
    defaultLanguage: "si",
  },
  LRD: {
    symbol: "$",
    name: "Liberian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "LRD",
    name_plural: "Liberian dollars",
    countryCode: "LR",
    defaultLanguage: "en",
  },
  LSL: {
    symbol: "L",
    name: "Lesotho Loti",
    symbol_native: "L",
    decimal_digits: 2,
    rounding: 0,
    code: "LSL",
    name_plural: "Lesotho lotis",
    countryCode: "LS",
    defaultLanguage: "en",
  },
  LTL: {
    symbol: "Lt",
    name: "Lithuanian Litas",
    symbol_native: "Lt",
    decimal_digits: 2,
    rounding: 0,
    code: "LTL",
    name_plural: "Lithuanian litas",
    countryCode: "LT",
    defaultLanguage: "lt",
  },
  LU: {
    symbol: "€",
    name: "Euro",
    symbol_native: "€",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros",
    countryCode: "LU",
    defaultLanguage: "fr",
  },
  LV: {
    symbol: "€",
    name: "Euro",
    symbol_native: "€",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros",
    countryCode: "LV",
    defaultLanguage: "lv",
  },
  LYD: {
    symbol: "د.ل",
    name: "Libyan Dinar",
    symbol_native: "د.ل",
    decimal_digits: 3,
    rounding: 0,
    code: "LYD",
    name_plural: "Libyan dinars",
    countryCode: "LY",
    defaultLanguage: "ar",
  },
  MA: {
    symbol: "د.م.",
    name: "Moroccan Dirham",
    symbol_native: "د.م.",
    decimal_digits: 2,
    rounding: 0,
    code: "MAD",
    name_plural: "Moroccan dirhams",
    countryCode: "MA",
    defaultLanguage: "ar",
  },
  MAD: {
    symbol: "د.م.",
    name: "Moroccan Dirham",
    symbol_native: "د.م.",
    decimal_digits: 2,
    rounding: 0,
    code: "MAD",
    name_plural: "Moroccan dirhams",
    countryCode: "EH",
    defaultLanguage: "ar",
  },
  MC: {
    symbol: "€",
    name: "Euro",
    symbol_native: "€",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros",
    countryCode: "MC",
    defaultLanguage: "fr",
  },
  MDL: {
    symbol: "lei",
    name: "Moldovan Leu",
    symbol_native: "lei",
    decimal_digits: 2,
    rounding: 0,
    code: "MDL",
    name_plural: "Moldovan lei",
    countryCode: "MD",
    defaultLanguage: "ro",
  },
  ME: {
    symbol: "€",
    name: "Euro",
    symbol_native: "€",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros",
    countryCode: "ME",
    defaultLanguage: "sr",
  },
  MGA: {
    symbol: "Ar",
    name: "Malagasy Ariary",
    symbol_native: "Ar",
    decimal_digits: 2,
    rounding: 0,
    code: "MGA",
    name_plural: "Malagasy ariarys",
    countryCode: "MG",
    defaultLanguage: "mg",
  },
  MKD: {
    symbol: "ден",
    name: "Macedonian Denar",
    symbol_native: "ден",
    decimal_digits: 2,
    rounding: 0,
    code: "MKD",
    name_plural: "Macedonian denars",
    countryCode: "MK",
    defaultLanguage: "mk",
  },
  ML: {
    symbol: "CFA",
    name: "CFA Franc BCEAO",
    symbol_native: "CFA",
    decimal_digits: 0,
    rounding: 0,
    code: "XOF",
    name_plural: "CFA francs BCEAO",
    countryCode: "ML",
    defaultLanguage: "fr",
  },
  MMK: {
    symbol: "K",
    name: "Myanmar Kyat",
    symbol_native: "K",
    decimal_digits: 2,
    rounding: 0,
    code: "MMK",
    name_plural: "Myanmar kyats",
    countryCode: "MM",
    defaultLanguage: "my",
  },
  MNT: {
    symbol: "₮",
    name: "Mongolian Tugrik",
    symbol_native: "₮",
    decimal_digits: 2,
    rounding: 0,
    code: "MNT",
    name_plural: "Mongolian tugriks",
    countryCode: "MN",
    defaultLanguage: "mn",
  },
  MOP: {
    symbol: "MOP$",
    name: "Macanese Pataca",
    symbol_native: "MOP$",
    decimal_digits: 2,
    rounding: 0,
    code: "MOP",
    name_plural: "Macanese patacas",
    countryCode: "MO",
    defaultLanguage: "zh",
  },
  MRU: {
    symbol: "UM",
    name: "Mauritanian Ouguiya",
    symbol_native: "UM",
    decimal_digits: 2,
    rounding: 0,
    code: "MRU",
    name_plural: "Mauritanian ouguiyas",
    countryCode: "MR",
    defaultLanguage: "ar",
  },
  MS: {
    symbol: "$",
    name: "East Caribbean Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "XCD",
    name_plural: "East Caribbean dollars",
    countryCode: "MS",
    defaultLanguage: "en",
  },
  MT: {
    symbol: "€",
    name: "Euro",
    symbol_native: "€",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros",
    countryCode: "MT",
    defaultLanguage: "mt",
  },
  MUR: {
    symbol: "Rs",
    name: "Mauritian Rupee",
    symbol_native: "Rs",
    decimal_digits: 2,
    rounding: 0,
    code: "MUR",
    name_plural: "Mauritian rupees",
    countryCode: "MU",
    defaultLanguage: "en",
  },
  MVR: {
    symbol: "Rf",
    name: "Maldivian Rufiyaa",
    symbol_native: "Rf",
    decimal_digits: 2,
    rounding: 0,
    code: "MVR",
    name_plural: "Maldivian rufiyaa",
    countryCode: "MV",
    defaultLanguage: "dv",
  },
  MWK: {
    symbol: "MK",
    name: "Malawian Kwacha",
    symbol_native: "MK",
    decimal_digits: 2,
    rounding: 0,
    code: "MWK",
    name_plural: "Malawian kwachas",
    countryCode: "MW",
    defaultLanguage: "ny",
  },
  MXN: {
    symbol: "$",
    name: "Mexican Peso",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "MXN",
    name_plural: "Mexican pesos",
    countryCode: "MX",
    defaultLanguage: "es",
  },
  MYR: {
    symbol: "RM",
    name: "Malaysian Ringgit",
    symbol_native: "RM",
    decimal_digits: 2,
    rounding: 0,
    code: "MYR",
    name_plural: "Malaysian ringgits",
    countryCode: "MY",
    defaultLanguage: "ms",
  },
  MZN: {
    symbol: "MT",
    name: "Mozambican Metical",
    symbol_native: "MT",
    decimal_digits: 2,
    rounding: 0,
    code: "MZN",
    name_plural: "Mozambican meticals",
    countryCode: "MZ",
    defaultLanguage: "pt",
  },
  NAD: {
    symbol: "$",
    name: "Namibian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "NAD",
    name_plural: "Namibian dollars",
    countryCode: "NA",
    defaultLanguage: "en",
  },
  NC: {
    symbol: "₣",
    name: "French Pacific Franc",
    symbol_native: "₣",
    decimal_digits: 0,
    rounding: 0,
    code: "XPF",
    name_plural: "French Pacific francs",
    countryCode: "NC",
    defaultLanguage: "fr",
  },
  NE: {
    symbol: "CFA",
    name: "CFA Franc BCEAO",
    symbol_native: "CFA",
    decimal_digits: 0,
    rounding: 0,
    code: "XOF",
    name_plural: "CFA francs",
    countryCode: "NE",
    defaultLanguage: "fr",
  },
  NF: {
    symbol: "$",
    name: "Australian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "AUD",
    name_plural: "Australian dollars",
    countryCode: "NF",
    defaultLanguage: "en",
  },
  NGN: {
    symbol: "₦",
    name: "Nigerian Naira",
    symbol_native: "₦",
    decimal_digits: 2,
    rounding: 0,
    code: "NGN",
    name_plural: "Nigerian nairas",
    countryCode: "NG",
    defaultLanguage: "en",
  },
  NIO: {
    symbol: "C$",
    name: "Nicaraguan Córdoba",
    symbol_native: "C$",
    decimal_digits: 2,
    rounding: 0,
    code: "NIO",
    name_plural: "Nicaraguan córdobas",
    countryCode: "NI",
    defaultLanguage: "es",
  },
  NL: {
    symbol: "€",
    name: "Euro",
    symbol_native: "€",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros",
    countryCode: "NL",
    defaultLanguage: "nl",
  },
  NO: {
    symbol: "kr",
    name: "Norwegian Krone",
    symbol_native: "kr",
    decimal_digits: 2,
    rounding: 0,
    code: "NOK",
    name_plural: "Norwegian kroner",
    countryCode: "NO",
    defaultLanguage: "no",
  },
  NOK: {
    symbol: "kr",
    name: "Norwegian Krone",
    symbol_native: "kr",
    decimal_digits: 2,
    rounding: 0,
    code: "NOK",
    name_plural: "Norwegian kroner",
    countryCode: "BV",
    defaultLanguage: "no",
  },
  NPR: {
    symbol: "Rs",
    name: "Nepalese Rupee",
    symbol_native: "Rs",
    decimal_digits: 2,
    rounding: 0,
    code: "NPR",
    name_plural: "Nepalese rupees",
    countryCode: "NP",
    defaultLanguage: "ne",
  },
  NR: {
    symbol: "$",
    name: "Australian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "AUD",
    name_plural: "Australian dollars",
    countryCode: "NR",
    defaultLanguage: "en",
  },
  NU: {
    symbol: "$",
    name: "New Zealand Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "NZD",
    name_plural: "New Zealand dollars",
    countryCode: "NU",
    defaultLanguage: "en",
  },
  NZ: {
    symbol: "$",
    name: "New Zealand Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "NZD",
    name_plural: "New Zealand dollars",
    countryCode: "NZ",
    defaultLanguage: "en",
  },
  NZD: {
    symbol: "$",
    name: "New Zealand Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "NZD",
    name_plural: "New Zealand dollars",
    countryCode: "CK",
    defaultLanguage: "en",
  },
  OMR: {
    symbol: "ر.ع.",
    name: "Omani Rial",
    symbol_native: "ر.ع.",
    decimal_digits: 3,
    rounding: 0,
    code: "OMR",
    name_plural: "Omani rials",
    countryCode: "OM",
    defaultLanguage: "ar",
  },
  PAB: {
    symbol: "B/.",
    name: "Panamanian Balboa",
    symbol_native: "B/.",
    decimal_digits: 2,
    rounding: 0,
    code: "PAB",
    name_plural: "Panamanian balboas",
    countryCode: "PA",
    defaultLanguage: "es",
  },
  PCN: {
    symbol: "$",
    name: "New Zealand Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "NZD",
    name_plural: "New Zealand dollars",
    countryCode: "PCN",
    defaultLanguage: "en",
  },
  PEN: {
    symbol: "S/",
    name: "Peruvian Nuevo Sol",
    symbol_native: "S/",
    decimal_digits: 2,
    rounding: 0,
    code: "PEN",
    name_plural: "Peruvian nuevos soles",
    countryCode: "PE",
    defaultLanguage: "es",
  },
  PGK: {
    symbol: "K",
    name: "Papua New Guinean Kina",
    symbol_native: "K",
    decimal_digits: 2,
    rounding: 0,
    code: "PGK",
    name_plural: "Papua New Guinean kinas",
    countryCode: "PG",
    defaultLanguage: "en",
  },
  PHP: {
    symbol: "₱",
    name: "Philippine Peso",
    symbol_native: "₱",
    decimal_digits: 2,
    rounding: 0,
    code: "PHP",
    name_plural: "Philippine pesos",
    countryCode: "PH",
    defaultLanguage: "tl",
  },
  PKR: {
    symbol: "₨",
    name: "Pakistani Rupee",
    symbol_native: "₨",
    decimal_digits: 2,
    rounding: 0,
    code: "PKR",
    name_plural: "Pakistani rupees",
    countryCode: "PK",
    defaultLanguage: "ur",
  },
  PLN: {
    symbol: "zł",
    name: "Polish Zloty",
    symbol_native: "zł",
    decimal_digits: 2,
    rounding: 0,
    code: "PLN",
    name_plural: "Polish zlotys",
    countryCode: "PL",
    defaultLanguage: "pl",
  },
  PLW: {
    symbol: "$",
    name: "US Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "USD",
    name_plural: "US dollars",
    countryCode: "PLW",
    defaultLanguage: "en",
  },
  PM: {
    symbol: "€",
    name: "Euro",
    symbol_native: "€",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros",
    countryCode: "PM",
    defaultLanguage: "fr",
  },
  PS: {
    symbol: "₪",
    name: "Israeli New Shekel",
    symbol_native: "₪",
    decimal_digits: 2,
    rounding: 0,
    code: "ILS",
    name_plural: "Israeli new shekels",
    countryCode: "PS",
    defaultLanguage: "he",
  },
  PYG: {
    symbol: "₲",
    name: "Paraguayan Guaraní",
    symbol_native: "₲",
    decimal_digits: 0,
    rounding: 0,
    code: "PYG",
    name_plural: "Paraguayan guaraníes",
    countryCode: "PY",
    defaultLanguage: "es",
  },
  RE: {
    symbol: "€",
    name: "Euro",
    symbol_native: "€",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros",
    countryCode: "RE",
    defaultLanguage: "fr",
  },
  RON: {
    symbol: "lei",
    name: "Romanian New Leu",
    symbol_native: "lei",
    decimal_digits: 2,
    rounding: 0,
    code: "RON",
    name_plural: "Romanian new lei",
    countryCode: "RO",
    defaultLanguage: "ro",
  },
  RSD: {
    symbol: "дин",
    name: "Serbian Dinar",
    symbol_native: "дин",
    decimal_digits: 2,
    rounding: 0,
    code: "RSD",
    name_plural: "Serbian dinars",
    countryCode: "RS",
    defaultLanguage: "sr",
  },
  RU: {
    symbol: "₽",
    name: "Russian Ruble",
    symbol_native: "₽",
    decimal_digits: 2,
    rounding: 0,
    code: "RUB",
    name_plural: "Russian rubles",
    countryCode: "RU",
    defaultLanguage: "ru",
  },
  RUB: {
    symbol: "₽",
    name: "Russian Ruble",
    symbol_native: "₽",
    decimal_digits: 2,
    rounding: 0,
    code: "RUB",
    name_plural: "Russian rubles",
    countryCode: "RU",
    defaultLanguage: "ru",
  },
  RWF: {
    symbol: "Fr",
    name: "Rwandan Franc",
    symbol_native: "Fr",
    decimal_digits: 0,
    rounding: 0,
    code: "RWF",
    name_plural: "Rwandan francs",
    countryCode: "RW",
    defaultLanguage: "rw",
  },
  SAR: {
    symbol: "ر.س",
    name: "Saudi Riyal",
    symbol_native: "ر.س",
    decimal_digits: 2,
    rounding: 0,
    code: "SAR",
    name_plural: "Saudi riyals",
    countryCode: "SA",
    defaultLanguage: "ar",
  },
  SBD: {
    symbol: "$",
    name: "Solomon Islands Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "SBD",
    name_plural: "Solomon Islands dollars",
    countryCode: "SB",
    defaultLanguage: "en",
  },
  SCR: {
    symbol: "₨",
    name: "Seychellois Rupee",
    symbol_native: "₨",
    decimal_digits: 2,
    rounding: 0,
    code: "SCR",
    name_plural: "Seychellois rupees",
    countryCode: "SC",
    defaultLanguage: "fr",
  },
  SDG: {
    symbol: "£",
    name: "Sudanese Pound",
    symbol_native: "£",
    decimal_digits: 2,
    rounding: 0,
    code: "SDG",
    name_plural: "Sudanese pounds",
    countryCode: "SD",
    defaultLanguage: "ar",
  },
  SEK: {
    symbol: "kr",
    name: "Swedish Krona",
    symbol_native: "kr",
    decimal_digits: 2,
    rounding: 0,
    code: "SEK",
    name_plural: "Swedish kronor",
    countryCode: "SE",
    defaultLanguage: "sv",
  },
  SGD: {
    symbol: "$",
    name: "Singapore Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "SGD",
    name_plural: "Singapore dollars",
    countryCode: "SG",
    defaultLanguage: "en",
  },
  SHP: {
    symbol: "£",
    name: "Saint Helena Pound",
    symbol_native: "£",
    decimal_digits: 2,
    rounding: 0,
    code: "SHP",
    name_plural: "Saint Helena pounds",
    countryCode: "SH",
    defaultLanguage: "en",
  },
  SJ: {
    symbol: "kr",
    name: "Norwegian Krone",
    symbol_native: "kr",
    decimal_digits: 2,
    rounding: 0,
    code: "NOK",
    name_plural: "Norwegian kroner",
    countryCode: "SJ",
    defaultLanguage: "no",
  },
  SK: {
    symbol: "€",
    name: "Euro",
    symbol_native: "€",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros",
    countryCode: "SK",
    defaultLanguage: "sk",
  },
  SLE: {
    symbol: "Le",
    name: "Sierra Leonean Leone",
    symbol_native: "Le",
    decimal_digits: 2,
    rounding: 0,
    code: "SLE",
    name_plural: "Sierra Leonean leones",
    countryCode: "SL",
    defaultLanguage: "en",
  },
  SM: {
    symbol: "€",
    name: "Euro",
    symbol_native: "€",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros",
    countryCode: "SM",
    defaultLanguage: "it",
  },
  SN: {
    symbol: "CFA",
    name: "CFA Franc BCEAO",
    symbol_native: "CFA",
    decimal_digits: 0,
    rounding: 0,
    code: "XOF",
    name_plural: "CFA francs",
    countryCode: "SN",
    defaultLanguage: "fr",
  },
  SOS: {
    symbol: "Sh",
    name: "Somali Shilling",
    symbol_native: "Sh",
    decimal_digits: 2,
    rounding: 0,
    code: "SOS",
    name_plural: "Somali shillings",
    countryCode: "SO",
    defaultLanguage: "so",
  },
  SRD: {
    symbol: "$",
    name: "Surinamese Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "SRD",
    name_plural: "Surinamese dollars",
    countryCode: "SR",
    defaultLanguage: "nl",
  },
  SSP: {
    symbol: "£",
    name: "South Sudanese Pound",
    symbol_native: "£",
    decimal_digits: 2,
    rounding: 0,
    code: "SSP",
    name_plural: "South Sudanese pounds",
    countryCode: "SS",
    defaultLanguage: "en",
  },
  STN: {
    symbol: "Db",
    name: "São Tomé and Príncipe Dobra",
    symbol_native: "Db",
    decimal_digits: 2,
    rounding: 0,
    code: "STN",
    name_plural: "São Tomé and Príncipe dobras",
    countryCode: "ST",
    defaultLanguage: "pt",
  },
  SX: {
    symbol: "ƒ",
    name: "Netherlands Antillean Guilder",
    symbol_native: "ƒ",
    decimal_digits: 2,
    rounding: 0,
    code: "ANG",
    name_plural: "Netherlands Antillean guilders",
    countryCode: "SX",
    defaultLanguage: "nl",
  },
  SYP: {
    symbol: "£",
    name: "Syrian Pound",
    symbol_native: "£",
    decimal_digits: 2,
    rounding: 0,
    code: "SYP",
    name_plural: "Syrian pounds",
    countryCode: "SY",
    defaultLanguage: "ar",
  },
  SZL: {
    symbol: "E",
    name: "Swazi Lilangeni",
    symbol_native: "E",
    decimal_digits: 2,
    rounding: 0,
    code: "SZL",
    name_plural: "Swazi lilangeni",
    countryCode: "SZ",
    defaultLanguage: "en",
  },
  TG: {
    symbol: "CFA",
    name: "CFA Franc BCEAO",
    symbol_native: "CFA",
    decimal_digits: 0,
    rounding: 0,
    code: "XOF",
    name_plural: "CFA francs",
    countryCode: "TG",
    defaultLanguage: "fr",
  },
  THB: {
    symbol: "฿",
    name: "Thai Baht",
    symbol_native: "฿",
    decimal_digits: 2,
    rounding: 0,
    code: "THB",
    name_plural: "Thai baht",
    countryCode: "TH",
    defaultLanguage: "th",
  },
  TJS: {
    symbol: "ЅМ",
    name: "Tajikistani Somoni",
    symbol_native: "ЅМ",
    decimal_digits: 2,
    rounding: 0,
    code: "TJS",
    name_plural: "Tajikistani somoni",
    countryCode: "TJ",
    defaultLanguage: "tg",
  },
  TK: {
    symbol: "$",
    name: "New Zealand Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "NZD",
    name_plural: "New Zealand dollars",
    countryCode: "TK",
    defaultLanguage: "en",
  },
  TMT: {
    symbol: "T",
    name: "Turkmenistani Manat",
    symbol_native: "T",
    decimal_digits: 2,
    rounding: 0,
    code: "TMT",
    name_plural: "Turkmenistani manats",
    countryCode: "TM",
    defaultLanguage: "tk",
  },
  TND: {
    symbol: "د.ت",
    name: "Tunisian Dinar",
    symbol_native: "د.ت",
    decimal_digits: 3,
    rounding: 0,
    code: "TND",
    name_plural: "Tunisian dinars",
    countryCode: "TN",
    defaultLanguage: "ar",
  },
  TOP: {
    symbol: "T$",
    name: "Tongan Paʻanga",
    symbol_native: "T$",
    decimal_digits: 2,
    rounding: 0,
    code: "TOP",
    name_plural: "Tongan paʻanga",
    countryCode: "TO",
    defaultLanguage: "to",
  },
  TRY: {
    symbol: "₺",
    name: "Turkish Lira",
    symbol_native: "₺",
    decimal_digits: 2,
    rounding: 0,
    code: "TRY",
    name_plural: "Turkish lira",
    countryCode: "TR",
    defaultLanguage: "tr",
  },
  TTD: {
    symbol: "$",
    name: "Trinidad Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "TTD",
    name_plural: "Trinidad dollars",
    countryCode: "TT",
    defaultLanguage: "en",
  },
  TV: {
    symbol: "$",
    name: "Australian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "AUD",
    name_plural: "Australian dollars",
    countryCode: "TV",
    defaultLanguage: "en",
  },
  TWD: {
    symbol: "NT$",
    name: "New Taiwan Dollar",
    symbol_native: "NT$",
    decimal_digits: 2,
    rounding: 0,
    code: "TWD",
    name_plural: "New Taiwan dollars",
    countryCode: "TW",
    defaultLanguage: "zh",
  },
  TZS: {
    symbol: "TSh",
    name: "Tanzanian Shilling",
    symbol_native: "TSh",
    decimal_digits: 2,
    rounding: 0,
    code: "TZS",
    name_plural: "Tanzanian shillings",
    countryCode: "TZ",
    defaultLanguage: "sw",
  },
  UAH: {
    symbol: "₴",
    name: "Ukrainian Hryvnia",
    symbol_native: "₴",
    decimal_digits: 2,
    rounding: 0,
    code: "UAH",
    name_plural: "Ukrainian hryvnias",
    countryCode: "UA",
    defaultLanguage: "uk",
  },
  UGX: {
    symbol: "USh",
    name: "Ugandan Shilling",
    symbol_native: "USh",
    decimal_digits: 2,
    rounding: 0,
    code: "UGX",
    name_plural: "Ugandan shillings",
    countryCode: "UG",
    defaultLanguage: "en",
  },
  UMI: {
    symbol: "$",
    name: "US Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "USD",
    name_plural: "US dollars",
    countryCode: "UM",
    defaultLanguage: "en",
  },
  US: {
    symbol: "$",
    name: "US Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "USD",
    name_plural: "US dollars",
    countryCode: "US",
    defaultLanguage: "en",
  },
  USD: {
    symbol: "$",
    name: "US Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "USD",
    name_plural: "US dollars",
    countryCode: "US",
    defaultLanguage: "en",
  },
  UYU: {
    symbol: "$",
    name: "Uruguayan Peso",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "UYU",
    name_plural: "Uruguayan pesos",
    countryCode: "UY",
    defaultLanguage: "es",
  },
  VC: {
    symbol: "$",
    name: "East Caribbean Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "XCD",
    name_plural: "East Caribbean dollars",
    countryCode: "VC",
    defaultLanguage: "en",
  },
  VES: {
    symbol: "Bs.S",
    name: "Sovereign Bolivar",
    symbol_native: "Bs.S",
    decimal_digits: 2,
    rounding: 0,
    code: "VES",
    name_plural: "Sovereign bolivars",
    countryCode: "VE",
    defaultLanguage: "es",
  },
  VND: {
    symbol: "₫",
    name: "Vietnamese Đồng",
    symbol_native: "₫",
    decimal_digits: 0,
    rounding: 0,
    code: "VND",
    name_plural: "Vietnamese đồng",
    countryCode: "VN",
    defaultLanguage: "vi",
  },
  VUV: {
    symbol: "VT",
    name: "Vanuatu Vatu",
    symbol_native: "VT",
    decimal_digits: 0,
    rounding: 0,
    code: "VUV",
    name_plural: "Vanuatu vatu",
    countryCode: "VU",
    defaultLanguage: "bi",
  },
  WF: {
    symbol: "₣",
    name: "French Pacific Franc",
    symbol_native: "₣",
    decimal_digits: 0,
    rounding: 0,
    code: "XPF",
    name_plural: "French Pacific francs",
    countryCode: "WF",
    defaultLanguage: "fr",
  },
  WST: {
    symbol: "T",
    name: "Samoan Tala",
    symbol_native: "T",
    decimal_digits: 2,
    rounding: 0,
    code: "WST",
    name_plural: "Samoan tala",
    countryCode: "WS",
    defaultLanguage: "sm",
  },
  XAF: {
    symbol: "Fr",
    name: "CFA Franc BEAC",
    symbol_native: "Fr",
    decimal_digits: 0,
    rounding: 0,
    code: "XAF",
    name_plural: "CFA francs BEAC",
    countryCode: "CF",
    defaultLanguage: "fr",
  },
  XCD: {
    symbol: "$",
    name: "East Caribbean Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "XCD",
    name_plural: "East Caribbean dollars",
    countryCode: "AG",
    defaultLanguage: "en",
  },
  XOF: {
    symbol: "Fr",
    name: "CFA Franc BCEAO",
    symbol_native: "Fr",
    decimal_digits: 0,
    rounding: 0,
    code: "XOF",
    name_plural: "CFA francs BCEAO",
    countryCode: "BJ",
    defaultLanguage: "fr",
  },
  XPF: {
    symbol: "₣",
    name: "French Pacific Franc",
    symbol_native: "₣",
    decimal_digits: 0,
    rounding: 0,
    code: "XPF",
    name_plural: "French Pacific francs",
    countryCode: "PF",
    defaultLanguage: "fr",
  },
  YER: {
    symbol: "ر.ي",
    name: "Yemeni Rial",
    symbol_native: "ر.ي",
    decimal_digits: 2,
    rounding: 0,
    code: "YER",
    name_plural: "Yemeni rials",
    countryCode: "YE",
    defaultLanguage: "ar",
  },
  YT: {
    symbol: "€",
    name: "Euro",
    symbol_native: "€",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros",
    countryCode: "YT",
    defaultLanguage: "fr",
  },
  YUN: {
    symbol: "дин",
    name: "Yugoslav Dinar",
    symbol_native: "дин",
    decimal_digits: 2,
    rounding: 0,
    code: "YUN",
    name_plural: "Yugoslav dinars",
    countryCode: "YU",
    defaultLanguage: "sr",
  },
  ZAR: {
    symbol: "R",
    name: "South African Rand",
    symbol_native: "R",
    decimal_digits: 2,
    rounding: 0,
    code: "ZAR",
    name_plural: "South African rands",
    countryCode: "ZA",
    defaultLanguage: "en",
  },
  ZMW: {
    symbol: "ZK",
    name: "Zambian Kwacha",
    symbol_native: "ZK",
    decimal_digits: 2,
    rounding: 0,
    code: "ZMW",
    name_plural: "Zambian kwachas",
    countryCode: "ZM",
    defaultLanguage: "en",
  },
  ZWL: {
    symbol: "Z$",
    name: "Zimbabwe Dollar",
    symbol_native: "Z$",
    decimal_digits: 2,
    rounding: 0,
    code: "ZWL",
    name_plural: "Zimbabwe dollars",
    countryCode: "ZW",
    defaultLanguage: "en",
  },
};